import { StoreDevtoolsModule } from '@ngrx/store-devtools';

export const IMPORTS = [StoreDevtoolsModule.instrument()];
